import { MenuBaseProps } from "./Menu";

export const MenuList: MenuBaseProps[] = [
  {
    icon: "svgModeration",
    title: "Moderation",
    path: "/moderation",
  },
  {
    icon: "svgTemplates",
    title: "Templates",
    path: "/templates",
  },
  {
    icon: "svgTemplates",
    title: "AI Review",
    path: "/aireview",
  },
  {
    // 전용 아이콘이 없어 Templates 아이콘을 함께 쓴다 (AI Review 와 같은 이유).
    icon: "svgTemplates",
    title: "Keywords",
    path: "/keywords",
  },
  {
    icon: "historyMenu",
    title: "History",
    path: "/history",
  },
  // {
  //   icon: 'svgDraft',
  //   title: 'Deleted',
  //   path: '/deleted'
  // },
  // {
  //   icon: 'svgGroup',
  //   title: 'History',
  //   path: '/history'
  // },
];
